export default "__VITE_ASSET__CGw21HI9__"